<template>
  <div>
    <!-- <i
      class="hamburger iconfont icondaohangzhediezhankai"
      :class="{'is-active':isActive}"
      @click="toggleClick"
    /> -->
    <img
      :src="closeImg"
      class="hamburger"
      :class="{'is-active':isActive}"
      @click="toggleClick"
    />
  </div>
</template>

<script>
import closeImg from '@/assets/icon_images/open.png'

export default {
  name: 'hamburger',
  data () {
    return {
      closeImg
    }
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
.hamburger {
    display: inline-block;
    cursor: pointer;
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin-top: -4px;
    transform: rotate(180deg);
    transition: .38s;
    transform-origin: 50% 50%;
    vertical-align: middle;
}

.hamburger.is-active {
    transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger/index.vue